import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Table } from 'react-bootstrap';

import './selectable_record_table.scss';

const SelectableRecordTable = (props) => {
  const onCheckboxChangeHandler = isIndeterminate => (
    isIndeterminate ? props.onResetSelection : props.onSelectAllToggle
  );

  const renderSelectAll = () => {
    const isIndeterminate = props.selectNoneVisible && !props.selectAllChecked;

    if (props.hasSelectAll) {
      return (
        <input
          aria-label="select all"
          checked={props.selectAllChecked}
          className="checkbox--lg"
          ref={input => input && (input.indeterminate = isIndeterminate)}
          type="checkbox"
          onChange={onCheckboxChangeHandler(isIndeterminate)}
        />
      );
    }
  };

  const tableClass = classNames(
    'bo-search-results table-selectable-rows table-hover',
    `table-sticky-col-${props.stickyColumns}`,
    {
      'sticky-column-shadow-border': props.stickyColShadow,
      'table-sticky-last-col': props.stickyLastColumn
    },
    props.className
  );

  return (
    <Table className={tableClass} {...props.tableProps}>
      <thead
        className={classNames(
          props.responsive ? 'hidden-xs hidden-sm condensed' : 'condensed',
          { 'sticky-header': props.stickyHeader },
        )}
      >
        <tr>
          {props.hasSelectColumn && (
            <th className="auto-size row-buffer" key="select-all">{renderSelectAll()}</th>
          )}
          {props.columnHeaders}
        </tr>
        {props.headerRows}
      </thead>
      <tbody>
        {props.children}
      </tbody>
      {props.renderFooter ? props.renderFooter() : null}
    </Table>
  );
};

SelectableRecordTable.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  columnHeaders: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  hasSelectAll: PropTypes.bool,
  hasSelectColumn: PropTypes.bool,
  headerRows: PropTypes.node,
  renderFooter: PropTypes.func,
  responsive: PropTypes.bool,
  selectAllChecked: PropTypes.bool,
  selectNoneVisible: PropTypes.bool,
  stickyColShadow: PropTypes.bool,
  stickyColumns: PropTypes.oneOf([0, 1, 2]),
  stickyHeader: PropTypes.bool,
  stickyLastColumn: PropTypes.bool,
  onResetSelection: PropTypes.func,
  onSelectAllToggle: PropTypes.func
};

SelectableRecordTable.defaultProps = {
  hasSelectAll: true,
  hasSelectColumn: true,
  responsive: true,
  selectAllChecked: false,
  selectNoneVisible: false,
  stickyColShadow: false,
  stickyColumns: 0,
  stickyHeader: false,
  stickyLastColumn: false
};

export default SelectableRecordTable;
